import { render, staticRenderFns } from "./goods3.vue?vue&type=template&id=97e8ef96&scoped=true"
import script from "./goods3.vue?vue&type=script&lang=js"
export * from "./goods3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e8ef96",
  null
  
)

export default component.exports